import React from 'react';
import cn from 'classnames';

import {
  isSpecialApiSourceForOperatorText,
  isVariationV3Route,
  isVariationV5Route,
  isCC,
} from '@shared/utils/general';

import { useAtomValue } from 'jotai';
import { useOperatorText } from '@features/phone-subscription/model/hooks/useOperatorText';
import { configAtom, type ConfigState, dcbAtom, subscriptionAtom } from '@shared/store/slice-atoms';
import { isAE } from '@entities/country';
import { Container } from 'react-bootstrap';
import '../styles/OperatorsMessage.module.css';

interface Props {
  isWhite?: boolean;
}

export const OperatorsMessage: React.FC<Props> = ({ isWhite = false }) => {
  const subscription = useAtomValue(subscriptionAtom);
  const dcb = useAtomValue(dcbAtom);
  const urlConfig = useAtomValue(configAtom) as ConfigState;

  const paymentMethod = subscription.paymentMethod;
  const homeData = dcb.homeData;
  const isV3Route = isVariationV3Route(dcb.variationKey);
  const isV5Route = isVariationV5Route(dcb.variationKey);

  const operatorMessage = useOperatorText();

  if (isV3Route) {
    return null;
  }

  const doesNotHaveDCB = Object.keys(urlConfig).find((el) => {
    const { hasDCB = true } = urlConfig[`${el}`].registrationSelectorConfig || {};
    return !hasDCB;
  });

  if (doesNotHaveDCB) {
    return null;
  }

  if (!operatorMessage) {
    return null;
  }

  const opacityClassname = isCC(paymentMethod) ? 'opacity-0' : '';

  const isSpecialApiSource = isSpecialApiSourceForOperatorText(homeData?.source);

  if (homeData.operators?.length && isAE(homeData.country) && isSpecialApiSource) {
    return (
      <Container
        style={isV5Route ? {} : isWhite ? { color: '#808080' } : { color: '#AEAEAE' }}
        className={cn(
          'container-sm',
          'pb-2',
          'pt-2',
          'text-center',
          'fs-10',
          'font-weight-700',
          'operator-message',
          opacityClassname
        )}
      >
        {operatorMessage}
      </Container>
    );
  }

  return homeData.operators?.length && isAE(homeData.country) ? (
    <Container
      className={cn(
        'container-sm',
        'pb-2',
        'pt-2',
        'text-center',
        'fs-10',
        'font-weight-700',
        'operator-message',
        opacityClassname
      )}
    >
      {operatorMessage}
    </Container>
  ) : null;
};
